<form *ngIf="caseStateFormGroup" [formGroup]="caseStateFormGroup">
    <p-message *ngIf="caseState.isSystem" severity="info" styleClass="mb-3 w-full"
        text="Este es un estado de sistema. Algunos datos no pueden ser modificados."></p-message>
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-4 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-2 input-field">
                <label for="backgroundColor">Color de fondo</label>
                <div class="flex gap-2">
                    <p-colorPicker [style.width]="'40px'" formControlName="backgroundColor" #backgroundColor d-form-field-error></p-colorPicker>
                    <input pInputText (change)="onColorChanged(backgroundColor)" [(ngModel)]="backgroundColor.inputBgColor" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
            <div class="col-2 input-field">
                <label for="foregroundColor">Color de texto</label>
                <div class="flex gap-2">
                    <p-colorPicker [style.width]="'40px'" formControlName="foregroundColor" #foregroundColor d-form-field-error></p-colorPicker>
                    <input pInputText (change)="onColorChanged(foregroundColor)" [(ngModel)]="foregroundColor.inputBgColor" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
        </div>
        <div class="grid pt-3">
            
            <div class="col-2 input-field">
                <label for="isInitial">Es inicial</label>
                <p-inputSwitch formControlName="isInitial" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-2 input-field">
                <label for="isFinal">Es final</label>
                <p-inputSwitch formControlName="isFinal" d-form-field-error></p-inputSwitch>
            </div>
            <div class="col-2 input-field">
                <label for="notUpdateWhenCaseServiceConfirmed">No actualizar cambiar al confirmar cita</label>
                <p-inputSwitch formControlName="notUpdateWhenCaseServiceConfirmed" d-form-field-error></p-inputSwitch>
            </div>
            
            <app-case-modes-switches [caseModes]="caseModes" [selectedIds]="selectedCaseModeIds"
                (selectedIdsChange)="selectedCaseModeIds = $event" [disabled]="!allowWrite"></app-case-modes-switches>

        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete && !caseState.isSystem" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>